import React from 'react'
import {
  Grid,
  GridCell,
  InputColor,
  FormElement,
  Flex,
  FlexItem,
  SpacingVertical,
  Divider
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  defaultStyleState,
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import { ParagraphRowHeader } from './ParagraphRowHeader'
import iconColors from '../../icons/cd-icon-colors.svg'
import styled from '@emotion/styled'

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`

export const ParagraphColor = () => {
  const intl = useIntl()
  const setPageState = useSetRecoilState(pageState)
  const { paragraph: defaultParagraph } = useRecoilValue(defaultStyleState)
  const { isEnabled } = useRecoilValue(pageState)

  const [
    {
      paragraph: { styles }
    },
    setContentDefaults
  ] = useRecoilState(styleState)

  const handleChangeTextColor = e => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))
    setContentDefaults(prev => ({
      ...prev,
      paragraph: {
        ...prev.paragraph,
        styles: {
          ...prev.paragraph.styles,
          color: e || defaultParagraph.styles.color
        }
      }
    }))
  }

  const handleChangeLinkColor = e => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))
    setContentDefaults(prev => ({
      ...prev,
      paragraph: {
        ...prev.paragraph,
        styles: {
          ...prev.paragraph.styles,
          linkColor: e || defaultParagraph.styles.linkColor
        }
      }
    }))
  }

  return (
    <>
      <ParagraphRowHeader
        title={'Load.ContentDefaults.CommonColorsTitle'}
        icon={iconColors}
      />
      <StyleGrid cols={12}>
        <GridCell span={4}>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.ColorsTextLabel'
            })}
          >
            <Flex alignItems={'center'}>
              <FlexItem>
                <InputColor
                  onChange={handleChangeTextColor}
                  value={styles.color}
                  disabled={!isEnabled}
                />
              </FlexItem>
            </Flex>
          </FormElement>
        </GridCell>
        <GridCell span={4}>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.ColorsLinkLabel'
            })}
          >
            <Flex alignItems={'center'}>
              <FlexItem>
                <InputColor
                  onChange={handleChangeLinkColor}
                  value={styles.linkColor}
                  disabled={!isEnabled}
                />
              </FlexItem>
            </Flex>
          </FormElement>
        </GridCell>
      </StyleGrid>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}
